import ArrowTopRight from '@assets/icons/arrow-top-right.svg';
import i18n from '@/utils/i18n';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { useRef } from 'react';

interface RestaurantNavigateButtonProps {
  isRowHovered: boolean;
  onPress: () => void;
}

export const RestaurantNavigateButton: React.FC<
  RestaurantNavigateButtonProps
> = ({ isRowHovered, onPress }) => {
  const [styles, theme] = useStyles();
  const buttonRef = useRef<React.ComponentRef<typeof Pressable>>(null);
  const isHovered = useHover(buttonRef);

  return (
    <Pressable
      accessibilityLabel={i18n.t(
        'sales_portal.restaurant_selector.view_account_details',
      )}
      onPress={onPress}
      ref={buttonRef}
      style={[
        styles.navigateButton,
        isHovered && styles.navigateButtonHovered,
        !isRowHovered && styles.navigateButtonHidden,
      ]}
    >
      <ArrowTopRight
        height={20}
        stroke={theme.sk.color.icon.primary}
        width={20}
      />
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  navigateButton: {
    alignItems: 'center',
    borderRadius: theme.sk.radii.radiusSmall,
    height: 20,
    justifyContent: 'center',
    width: 20,
  },
  navigateButtonHidden: {
    opacity: 0,
  },
  navigateButtonHovered: {
    backgroundColor: theme.sk.color.bg.primary.hover,
  },
}));
